export default __webpack_public_path__ + "static/media/download-app-store-button.10ac7878.svg";